export default __webpack_public_path__ + "static/media/epitech_image1.7fd07040.jpg";